import { FC, memo, useRef } from 'react'
import Box from '@mui/material/Box'
import CompanyPaymentsTable from '../CompanyPaymentsTable'

const CompanyPaymentsPanel: FC = () => {
  const ref = useRef<HTMLElement>(null)
  return (
    <Box
      ref={ref}
      id="company-payments-panel"
      sx={theme => ({
        overflow: 'scroll',
        display: 'flex',
        flex: 1,
        backgroundColor: 'white',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 2,
        [theme.breakpoints.down('sm')]: {
          paddingTop: '70px',
        },
      })}
    >
      <CompanyPaymentsTable scrollContainerRef={ref} />
    </Box>
  )
}

export default memo(CompanyPaymentsPanel)
